( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '#projects-filter-form input' ).on( 'change', function() {
        $( '#projects-filter-form' ).submit();
      } );
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'projects-archive', COMPONENT );
} )( app );
